import i18next from 'i18next';
import type { HttpBackendOptions } from 'i18next-http-backend';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

void i18next
	.use(Backend)
	.use(initReactI18next)
	.init<HttpBackendOptions>({
		lng: 'en',
		fallbackLng: false,
		ns: ['common', 'validations'],
		fallbackNS: 'common',
		defaultNS: 'common',

		nsSeparator: ':',

		interpolation: {
			escapeValue: false, // not needed for React
		},

		backend: {
			requestOptions: {
				cache: 'no-store',
			},
			queryStringParams: {
				v: process.env.NX_PUBLIC_APP_VERSION || 'development',
			},
		},

		react: {
			useSuspense: true,
		},

		debug: import.meta.env.DEV,
	});

// Keep custom formatters in sync with apps/backend/src/i18next.ts.
i18next.services.formatter?.add('lowercase', (value) => {
	return value.toLowerCase();
});

// Reload translation files on HMR updates in development.
if (import.meta.hot) {
	import.meta.hot.on('vite:afterUpdate', () => {
		void i18next.reloadResources().then(() => i18next.changeLanguage('en'));
	});
}
